import React from 'react';

const CustomersPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-gray-900">Customers</h1>
      <p>Customer management coming soon...</p>
    </div>
  );
};

export default CustomersPage;